"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = throttle;
function throttle(func, wait = 100, options = {}) {
    let timeout = null;
    let previous = 0;
    let lastArgs = null;
    let lastThis = null;
    const { leading = true, trailing = true } = options;
    const later = () => {
        previous = leading ? Date.now() : 0;
        timeout = null;
        if (lastArgs) {
            func.apply(lastThis, lastArgs);
            lastArgs = lastThis = null;
        }
    };
    const throttled = function (...args) {
        const now = Date.now();
        if (!previous && !leading) {
            previous = now;
        }
        const remaining = wait - (now - previous);
        lastArgs = args;
        lastThis = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            return func.apply(this, args);
        }
        if (!timeout && trailing) {
            timeout = setTimeout(later, remaining);
        }
    };
    return throttled;
}
